module.exports = __webpack_public_path__ + "images/ando.2923488ca93fc10357c1bf6bdc7dac58.png";